export default __webpack_public_path__ + "static/404-fbe447db714bc9907d2a23690738393f.gif";